var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHexaludLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0371 7.80463L22.4306 10.2762V15.2193L18.0371 17.6909L13.6436 15.2193V10.2762L18.0371 7.80463Z",
    fill: "#B6FCD2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7428 15.0883L18.0236 17.5599V22.503L13.7428 24.9745L9.46191 22.503V17.5599L13.7428 15.0883Z",
    fill: "#86F2B1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58164 7.80463L13.8625 10.2762V15.2193L9.58164 17.6909L5.30078 15.2193V10.2762L9.58164 7.80463Z",
    fill: "#00C46B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7438 3.01023L2.60164 9.4959V22.5041L13.7438 28.9898L24.886 22.5041V9.4959L13.7438 3.01023ZM27.4876 7.99998L13.7438 -6.10352e-05L0 7.99998V24.0001L13.7438 32.0001L27.4876 24.0001V7.99998Z",
    fill: "#86F2B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexaludLogo);
export default __webpack_public_path__ + "static/media/hexaludLogo.dbcb397f525f0079fc3b15f38a087352.svg";
export { ForwardRef as ReactComponent };